import { useState, useLayoutEffect } from "react";
import useResizeObserver from "@react-hook/resize-observer";
import debounce from "lodash/debounce";
const useElementDimensions = (target, debounceDelay = 200) => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const debouncedUpdate = debounce((newDimensions) => setDimensions(newDimensions), debounceDelay);
  useLayoutEffect(() => {
    if (target && "current" in target && target.current) {
      const { width, height } = target.current.getBoundingClientRect();
      setDimensions({ width, height });
    }
  }, [target]);
  useResizeObserver(target, ({ contentRect: { width, height } }) => {
    debouncedUpdate({ width, height });
  });
  return dimensions;
};
export default useElementDimensions;
